import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
} from "@heroui/react";
import { IconDeviceFloppy } from "@tabler/icons-react";
import { useResumeBuilder } from "../context";
import type { JobExperience, Training } from "../types";
import { ExperienceForm } from "./experience-form";

type FormData = JobExperience | Training;

interface ExperienceModalProps {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    onFormSubmit: (data: FormData) => void;
    initialData?: Partial<FormData>;
    type: "experience" | "training";
}

const ExperienceModal = ({
    title,
    isOpen,
    onClose,
    onFormSubmit,
    initialData,
    type,
}: ExperienceModalProps) => {
    const { design } = useResumeBuilder();

    return (
        <Modal
            isOpen={isOpen}
            onOpenChange={onClose}
            backdrop="blur"
            size="3xl"
            // fixes: https://github.com/heroui-inc/heroui/issues/3937#issuecomment-2620261488
            placement="center"
            shouldBlockScroll={false}
            disableAnimation={true}
            classNames={{ wrapper: "items-start h-auto", base: "my-auto" }}
        >
            <ModalContent>
                {(close) => (
                    <>
                        <ModalHeader>{title}</ModalHeader>
                        <ModalBody>
                            <ExperienceForm
                                isOpen={isOpen}
                                onClose={close}
                                onFormSubmit={onFormSubmit}
                                initialData={initialData}
                                type={type}
                            />
                        </ModalBody>
                        <ModalFooter className="justify-right flex">
                            <Button
                                color="danger"
                                variant="light"
                                onPress={close}
                            >
                                Abbrechen
                            </Button>
                            <Button
                                type="submit"
                                form="experience-form"
                                style={{
                                    backgroundColor: design.resumePrimaryColor,
                                    color: design.resumePrimaryContrastColor,
                                }}
                                startContent={
                                    <IconDeviceFloppy stroke={1.5} size={20} />
                                }
                            >
                                Speichern
                            </Button>
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

export { ExperienceModal };
